import {useQuery} from "@tanstack/react-query";
import {DevourPlayApi, MyNetworkStatusResponse, Token} from "@devour/client";
import getConfig from "@/utils/getConfig";

export const USE_GET_MY_NETWORK_STATUS_KEY = "my-network-status";

async function fetchMyNetworkStatus(fullToken?: Token): Promise<MyNetworkStatusResponse> {
    return new DevourPlayApi(getConfig(fullToken)).getDevourplayMyNetworkStatus();
}

/**
 * Current-session network status (VPN / hosting flags) for the DevourPlay login
 * warning. Cached long-ish — a session's VPN state rarely flips mid-session, and
 * the backend read is itself IP-cached, so there's no value in frequent refetch.
 */
/** Token optional: the signup form reads this before an account exists. */
export function useGetMyNetworkStatus(fullToken?: Token, disabled?: boolean) {
    return useQuery({
        queryKey: [USE_GET_MY_NETWORK_STATUS_KEY, fullToken?.id ?? "anon"],
        queryFn: () => fetchMyNetworkStatus(fullToken),
        staleTime: 30 * 60000,
        refetchOnWindowFocus: false,
        enabled: !disabled,
    });
}
